import Header from './components/Header';
import Hero from './components/Hero';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import FAQSection from './components/FAQSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CommentsSection />
        <AppSection />
        <AboutSection />
        <CarouselSection />
        <FeaturesSection />
        <RankingSection />
        <ContactSection />
        <TopicsSection />
        <MediaSection />
        <CardsSection />
        <UpdatesSection />
        <FAQSection />
        <IndexSection />
      </main>
      <Footer />
    </div>
  );
}